<template>
  <div class="trend-other">
    <div class="trend-other-header">
      <div class="trend-other-header-left">{{ title }}</div>
      <div class="trend-other-header-right">
        <div class="other-btn"><span style="color:#a3a3a3">开始时间:</span></div>
        <div class="other-btn"><el-date-picker v-model="startTime" type="date" size="mini" placeholder="选择日期"
            popper-class="other-data">
          </el-date-picker></div>
        <div class="other-btn"><span style="color:#a3a3a3">结束时间:</span></div>
        <div class="other-btn"><el-date-picker popper-class="other-data" v-model="stopTime" type="date" size="mini"
            placeholder="选择日期">
          </el-date-picker></div>
        <div class="other-btn" @click="updataCustomTime"><span>确定</span></div>
      </div>

    </div>
    <div class="bottom-line"></div>
    <div class="trend-other-content">
      <div class="annon" ref="echartsBar"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import service from '../../service/leftService.js'
import echarts from 'echarts'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      xValue: [],
      titValue: [],
      serValue: [],
      startTime: moment(),
      stopTime: moment(),
      middle_height: `${document.documentElement.clientHeight - 140}`,
      nodeData: {},
      title: "柱状图",
      updateTreeNode: {}
    };
  },

  components: {},

  computed: {

  },

  beforeMount() { },

  mounted() {
    let _this = this
    this.nodeData = JSON.parse(this.$route.query.nodeData)
    this.updateTreeNode = JSON.parse(this.$route.query.updateTreeNode)
    this.title = this.nodeData.fullName
    this.stopTime = moment().valueOf()
    this.startTime = moment().subtract(30, "days").valueOf()
    this.$nextTick(() => {
      _this.initCharts();
    })
  },

  methods: {
    initCharts() {
      this.serValue = []
      if (this.updateTreeNode) {
        this.nodeDataInfo = this.updateTreeNode
      } else {
        this.nodeDataInfo = this.nodeData
      }
      let a = Date.now()
      let _this = this
      let colorList = ['#93d9fe', '#529855', '#ab6d58', '#dcdc9e', '#c1cbcc', '#c485b5', '#027bcc', '#121cdd', '#52c41a', '#ff9502', '#ff5d00', '#ff0000', '#ff5656', '#09a4d7'];
      let data = {
        "startTime": this.startTime,
        "stopTime": this.stopTime,
        "ids": []
      }
      data.ids = [...this.nodeDataInfo.attribute.arr]
      service.getHistogram(data).then(res => {
        _this.xValue = [...res[0].times]
        res[0].val.forEach((item, index) => {
          _this.titValue.push(item.pointName)
          let obj = {
            name: item.pointName,
            type: 'bar',
            data: [],
            barWidth: 15, //柱子宽度
            barGap: 0, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: colorList[index]
                }, {
                  offset: 1,
                  color: colorList[index]
                }]),
                opacity: 1,
              }
            }
          }
          for (let i = 0; i < item.value.length; i++) {
            obj.data.push(item.value[i][1])
          }
          _this.serValue.push(obj)
        });
        this.echartsBar = echarts.init(this.$refs.echartsBar);
        this.echartsBar.setOption(
          {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            title: {
              subtext: _this.nodeDataInfo.attribute.unit,
              left: "2%"
            },
            legend: {
              data: this.titValue, // this.titValue
              align: 'right',
              right: 70,
              top: 10,
              textStyle: {
                color: "#fff"
              },
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 0
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: res[0].times,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#c1dbd5",
                  width: 1,
                  type: "solid"
                }
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#c1dbd5",
                }
              },
            }],
            yAxis: [{
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#c1dbd5",
                  width: 1,
                  type: "solid"
                },
              },
              splitLine: {
                lineStyle: {
                  color: "#3d3e3e",
                }
              }
            }],
            "dataZoom": [{
              "show": true,
              "height": 30,
              "xAxisIndex": [
                0
              ],
              bottom: 0,
              "start": 10,
              "end": 80,
              handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
              handleSize: '110%',
              handleStyle: {
                color: "#d3dee5",

              },
              textStyle: {
                color: "#fff"
              },
              borderColor: "#90979c"


            }, {
              "type": "inside",
              "show": true,
              "height": 15,
              "start": 1,
              "end": 35
            }],
            series: this.serValue
          }

        )
        window.addEventListener('resize', () => {
          this.echartsBar.resize()
        })
      })
    },
    updateTime(val) {
      let _this = this
      this.echartdloading = true
      this.nodeData.attribute.stopTime = moment().valueOf()
      if (val === 'day') {
        this.nodeData.attribute.startTime = moment().subtract(3, "days").valueOf()
        _this.initCharts();
      }
      if (val === 'week') {
        this.nodeData.attribute.startTime = moment().subtract(7, "days").valueOf()
        _this.initCharts();
      }
      if (val === 'months') {
        this.nodeData.attribute.startTime = moment().subtract(1, "months").valueOf()
        _this.initCharts();
      }

    },
    updataCustomTime() {
      let _this = this
      this.startTime = this.startTime.valueOf()
      this.stopTime = this.stopTime.valueOf()
      _this.initCharts();

    }
  },

  watch: {}

}

</script>
<style lang='scss' scoped>
.trend-other {
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);

  .trend-other-header {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 20px;

    .trend-other-header-left {
      color: #dfdfdf;
      font-size: 1.5vh;
    }

    .trend-other-header-right {
      width: 60%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .other-btn {
      color: rgb(255, 98, 0);
      margin-right: 20px;
      font-size: 1.5vh;
      cursor: pointer;
      padding-top: 3px;
    }
  }

  .bottom-line {
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, #204da733 0%, #8e8e8e 50%, #204da733 100%);
  }

  .trend-other-content {
    width: 100%;
    height: calc(100% - 42px);
    box-sizing: border-box;
    padding: 10px 10px;
  }
}

.annon {
  width: 100%;
  height: 100%;
}

.other-btn>>>.el-input--mini .el-input__inner {
  height: 23px;
  line-height: 23px;
  color: #a3a3a3;
}

.other-btn>>>.el-input--mini .el-input__icon {
  line-height: 25px;
}

.test {
  color: #222744;
}
</style>


// WEBPACK FOOTER //
// src/components/timeChart/energyBarShowOther.vue